import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'

import { PushManager } from '@/components/common/PushManager'
import MobileAppShell from '@/components/layout/MobileAppShell'
import { AuthProvider } from '@/hooks/useAuth'
import '@/i18n'
import { initPwa } from '@/pwa'
import '@/styles/global.css'
import router from '@/router'

initPwa()

createRoot(document.getElementById('root')!).render(
  <AuthProvider>
    <PushManager />
    <MobileAppShell>
      <RouterProvider router={router} />
    </MobileAppShell>
  </AuthProvider>,
)
